import { Box, Grid, Paper, type PaperProps, Stack } from '@mui/material'
import React, { type ReactNode } from 'react'

import { PromotedScenarioPreviewChips } from 'components/test-suites/forms/test-suite-composition/PromotedScenarioPreviewChips'
import theme from 'theme'

import type { ScenarioPreview } from 'types/api/reliability-tests/preview'
import type {
  FailureFlagNode,
  GraphNode,
  InfraAttackNode
} from 'types/api/scenarios/scenario'

export const GraphNodeWrapper: React.FC<
  {
    details: ReactNode
    impact: ReactNode
    isClickable: boolean
    node: InfraAttackNode | FailureFlagNode
    onClick?: (node: GraphNode) => void
    rowActions?: ReactNode
    scenarioPreview?: ScenarioPreview
  } & Omit<PaperProps, 'children'>
> = ({
  details,
  impact,
  isClickable,
  node,
  onClick,
  rowActions,
  scenarioPreview,
  ...rest
}) => {
  return (
    <Paper
      sx={{
        width: 'fit-content',
        minWidth: 500,
        maxWidth: 800,
        padding: 1,
        margin: `${theme.space[3]}px 0`
      }}
      onClick={isClickable && onClick ? () => onClick(node) : undefined}
      {...rest}
    >
      <Stack>
        <Grid
          container
          alignItems="center"
          justifyContent="space-between"
          spacing={1}
        >
          <Grid item aria-label="Experiment" xs={5}>
            <Stack
              sx={{
                alignItems: 'center',
                flexDirection: 'row',
                justifyContent: 'flex-start'
              }}
            >
              {details}
            </Stack>
          </Grid>
          <Grid item xs={6}>
            <Stack
              sx={{
                alignItems: 'center',
                flexDirection: 'row',
                justifyContent: 'flex-start'
              }}
            >
              {impact}
            </Stack>
          </Grid>
          <Grid item xs={1}>
            {rowActions}
          </Grid>
        </Grid>
      </Stack>
      {scenarioPreview && (
        <Box mt={1}>
          <PromotedScenarioPreviewChips
            scenarioPreview={scenarioPreview}
            step={node}
          />
        </Box>
      )}
    </Paper>
  )
}
